import { z } from 'zod'

export const AgentSessionDtoSchema = z.object({
  id: z.string(),
  agent_id: z.number(),
  title: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  preview: z.string().nullable(),
  public_scope_id: z.string(),
})

export const AgentInvokeEnvelopeDtoSchema = z.object({
  response: z.string(),
  agent_id: z.number(),
  trace_id: z.string(),
  session_id: z.string(),
  output_files: z.array(z.unknown()),
})

const SkillCallDtoSchema = z.object({
  type: z.literal('skill_call'),
  call_id: z.string(),
  name: z.string(),
  args: z.record(z.string(), z.unknown()),
})

const AgentFinalDtoSchema = z.object({
  type: z.literal('final'),
  content: z.string(),
  info_note: z.string().nullable(),
  document_changed: z.boolean(),
})

export const AgentTurnDtoSchema = z.discriminatedUnion('type', [
  SkillCallDtoSchema,
  AgentFinalDtoSchema,
])

export type AgentSessionDto = z.infer<typeof AgentSessionDtoSchema>

export type AgentInvokeEnvelopeDto = z.infer<typeof AgentInvokeEnvelopeDtoSchema>

export type AgentTurnDto = z.infer<typeof AgentTurnDtoSchema>
